import { Component, OnInit, ElementRef, Output, ViewChild, Input, EventEmitter, Injector } from '@angular/core';
import { TournamentsService } from '../tournaments/services/tournaments.service';
import { uiHelper } from '~/helpers/ui.helper';
import { AppComponentBase } from '../../../shared/app-component-base';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_livebetfooter',
    templateUrl: './livebetfooter.html',
})
export class LiveBetFooter extends AppComponentBase implements OnInit {
    livebet_footer_menu_active = 0;
    livebet_today = new Date();
    livebet_today_day;
    livebet_today_month;
    livebet_newdate = new Date(this.livebet_today);
    livebet_dd;
    livebet_mm;
    livebet_y;
    livebet_someFormattedDate;
    livebet_dayArray = [];

    livebet_weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    livebet_dayname = [];

    //@Output('selecteddate') selecteddate = new EventEmitter();

    constructor(
        public tournamentsService: TournamentsService,
        private _uiHelper: uiHelper,
        private _injector: Injector,
    ) {
        super(_injector);
    }

    init: boolean;

    isShowDayChangeArea = true;

    ngOnInit() {
        if (this.init) return;
        this.init = true;
        this.tournamentsService.TerminalSearchValue = '';
        this.livebet_today_day = this.livebet_today.getDate();
        this.livebet_today_month = this.livebet_today.getMonth() + 1;
        if (this.livebet_today_day < 10) {
            this.livebet_today_day = '0' + this.livebet_today_day;
        }
        if (this.livebet_today_month < 10) {
            this.livebet_today_month = '0' + this.livebet_today_month;
        }
        this.livebet_dayArray[0] =
            this.livebet_today_day + '.' + this.livebet_today_month + '.' + this.livebet_today.getFullYear();
        this.livebet_dayname[0] = this.livebet_weekday[this.livebet_today.getDay()];
        this.Livebet_showDay();

        this.tournamentsService._livebetfooterDayisActive = false;

        this.tournamentsService.fixturedate = this.livebet_dayArray[0].replace(/\./g, '/');
        this.livebet_footer_menu_active = 0;
        //this.tournamentsService.getSportFixture("livebetfooter.ts");
        //Gereksiz bir çağrım

        ////
        //this.Livebet_footerdateSelected(0, this.livebet_dayArray[0]);

        this._uiHelper.tournamentType_Listener.subscribe(x => {
            if (x != 0) {
                this.isShowDayChangeArea = false;
            } else {
                this.isShowDayChangeArea = true;
            }
        });
    }

    Livebet_showDay() {
        for (let _i = 1; _i < 14; _i++) {
            this.livebet_newdate.setDate(this.livebet_newdate.getDate() + 1);
            this.livebet_dd = this.livebet_newdate.getDate();
            if (this.livebet_dd < 10) {
                this.livebet_dd = '0' + this.livebet_dd;
            }
            this.livebet_mm = this.livebet_newdate.getMonth() + 1;
            if (this.livebet_mm < 10) {
                this.livebet_mm = '0' + this.livebet_mm;
            }
            this.livebet_y = this.livebet_newdate.getFullYear();
            this.livebet_dayname[_i] = this.livebet_weekday[this.livebet_newdate.getDay()];
            this.livebet_someFormattedDate = this.livebet_dd + '.' + this.livebet_mm + '.' + this.livebet_y;

            this.livebet_dayArray.push(this.livebet_someFormattedDate);
        }
    }

    Livebet_footerdateSelected(i, livebet_selectedday) {
        this.tournamentsService.TerminalSearchValue = '';
        this.tournamentsService.fixturedate = livebet_selectedday.replace(/\./g, '/');
        this.livebet_footer_menu_active = i;

        this._uiHelper.setDateTodayStatus(i === 0);

        this.tournamentsService.getSportFixture('livebetfooter');
        //this.tournamentsService.getAllUpcoming();
        //this.tournamentsService.activeSport = "";
        if (livebet_selectedday.replace(/\./g, '/') != this.livebet_dayArray[0].replace(/\./g, '/')) {
            this.tournamentsService._livebetfooterDayisActive = true;
        } else this.tournamentsService._livebetfooterDayisActive = false;

        //this.selecteddate.next(selectedday);
    }

    upScrollLiveBetFooter() {
        this._uiHelper.setScrollChange('down');
    }

    downScrollLiveBetFooter() {
        this._uiHelper.setScrollChange('up');
    }

    Keyboard_Search_Open_Modal() {
        SetLanguage('', '');
        $('#LiveBets_Keyboard_Search_Modal')
            .modal({
                detachable: false,
                closable: false,
                dimmerSettings: {
                    opacity: 0,
                },
            })
            .modal('show');
    }

    Results_Modal_Open_From_Live() {
        this.tournamentsService.getResultTerminal();
        $('#ResultModal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    OpenExplanationModalLive() {
        $('#explanation_modal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    TicketKeyboardModalOpen() {
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';
        $('#TicketKeyboardModal').modal('show');
    }
}
